import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentService } from '../../providers/document.service';
import { DocumentSignatureRequestService } from '../../providers/document-signature-request.service';
import { Document } from '../../models/document';
import { Document_signature_request } from '../../models/document_signature_request';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { faCheck } from '@fortawesome/fontawesome-pro-regular';
import { faPenNib } from '@fortawesome/pro-regular-svg-icons';

@Component({
  standalone: false,
  selector: 'app-sign-document',
  templateUrl: './sign-document.component.html',
styleUrls:  ['./sign-document.component.css']
})
export class SignDocumentComponent extends SmsAbstractAppPage implements OnInit {

	faCheck = faCheck;
	faPenNib = faPenNib;
	submitted: boolean = false;
	response: string = '';
	already_signed: boolean = false;

	document: Document = new Document({});
  dsr: Document_signature_request = new Document_signature_request({});

  constructor(private route: ActivatedRoute, private documentService: DocumentService, private documentSignatureRequestService: DocumentSignatureRequestService) {
  	super();
  }

  ngOnInit() {

  	this.route.params.subscribe(params => {
          if(params['id']){
          	this.documentSignatureRequestService.get(params['id']).then(document_signature_request => {
          		this.dsr = document_signature_request;
              if(document_signature_request.id != undefined && (document_signature_request.terms_accepted && document_signature_request.terms_understood && document_signature_request.signature != '')){
                this.already_signed = true;
              }

              this.documentService.get(document_signature_request.document_id).then(document => {
                this.document = document;
              }).catch(error => {
                this.handleError(error);
              });

          	}).catch(error => {
          		this.handleError(error);
          	});
          }
  	});

   }

   handleSubmitSignature() {

     let errors: string[] = [];

   	if(this.dsr.signature == null || this.dsr.signature == ''){
       errors.push("This document must be signed!");
    }
    if(this.dsr.terms_accepted == null || this.dsr.terms_accepted != true){
      errors.push("To electronically sign this document you must indicate that you accept its terms!");
    }

    if(this.dsr.terms_understood == null || this.dsr.terms_understood != true){
      errors.push("To electronically sign this document you must indicate that you understand that signing a document electronically is as binding as signing it in ink!");
    }

    if(errors.length == 0){
      this.submitted = true;
      this.documentSignatureRequestService.updateSignature(this.dsr).then(response => {
        this.response = response;
      }).catch(error => {
        this.handleError(error);
        this.submitted = false;
      });
    } else {
      errors.forEach((error, i) => {
        this.handleError(error);
      });
    }



   }

}
